import { render, staticRenderFns } from "./TransactionLog.vue?vue&type=template&id=0316ff98"
import script from "./TransactionLog.vue?vue&type=script&lang=js"
export * from "./TransactionLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports